/**
 *  图片展示 （适配写法兼容qq浏览器）
 */
// import { Typography } from 'antd';
import React from 'react';
// import style from './index.less'

const ImgDisplay = (props) => {
  // eslint-disable-next-line react/prop-types
  const { src, width = '100px', height = 'auto', alt = '图片' } = props;

  return (
    <div style={{ width, height }}>
      <img src={src} alt={alt} style={{ width: '100%' }} />
    </div>
  );
};

export default ImgDisplay;
